module.exports = __webpack_public_path__ + "static/fonts/NotoSans-DemiLight.3426347.otf";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-DemiLight.otf
// module id = 5pP6
// module chunks = 0